import { render, staticRenderFns } from "./UpdatePrivilege.vue?vue&type=template&id=464e10ec"
import script from "./UpdatePrivilege.vue?vue&type=script&lang=js"
export * from "./UpdatePrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports